// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundDefault": "#fcfcfc",
	"backgroundDark": "#1a1a19",
	"containerSubtle": "#f5f3f1",
	"containerDark": "#262626",
	"borderDefault": "#efedea",
	"containerInverse": "#262626",
	"containerDefault": "#fff",
	"borderStrong": "#dbd9d7",
	"dividerDefault": "rgba(0,0,0,.08)",
	"dividerInverse": "hsla(0,0%,100%,.2)",
	"borderInverse": "#575655",
	"interactiveBrand": "#f36805",
	"interactivePrimary": "#262626",
	"interactiveInverse": "#fff",
	"interactiveSecondary": "#f5f3f1",
	"interactiveLight": "#fff",
	"supportError": "#d50525",
	"supportDarkError02": "#491e24",
	"overlay": "rgba(0,0,0,.55)",
	"supportPositive": "#017a39",
	"interactiveForm": "#797876",
	"supportWarning": "#f6c243",
	"supportInfo": "#125fca",
	"supportNeutral": "#efedea",
	"supportWarning02": "#fff9df",
	"supportError02": "#ffe9ea",
	"supportInfoInverse": "#7aadf6",
	"supportPositive02": "#e5faef",
	"supportInfo02": "#ebf6fa",
	"containerStrong": "#efedea",
	"supportPositiveInverse": "#22bf65",
	"supportBrand01": "#ff8000",
	"supportBrand03": "#c1dade",
	"supportBrand04": "#f2a6b0",
	"supportBrand06": "#5b3d5b",
	"supportBrand07": "#f75e28",
	"supportBrand05": "#f6c243",
	"contentDefault": "#242e30",
	"contentSubdued": "#3c4c4f",
	"contentInteractiveLight": "#fff",
	"contentInteractiveBrand": "#f36805",
	"contentInteractivePrimary": "#fff",
	"contentInteractiveSecondary": "#242e30",
	"contentInteractiveInverse": "#242e30",
	"contentInteractiveDark": "#242e30",
	"contentInteractiveTertiary": "#303d3f",
	"contentLight": "#fff",
	"contentInteractiveError": "#d50525",
	"contentLink": "#242e30",
	"contentInverse": "#fff",
	"contentLinkDistinct": "#125fca",
	"contentLinkLight": "#fff",
	"backgroundSubtle": "#f5f3f1",
	"contentError": "#d50525",
	"contentLinkVisited": "purple",
	"contentLinkVisitedInverse": "#c58af9",
	"contentDisabled": "#8c999b",
	"contentLinkInverse": "#fff",
	"contentBrand": "#f36805",
	"hover02": "8%",
	"active01": "12%",
	"hover01": "4%",
	"focus": "#fff",
	"focusOuter": "#094dac",
	"active02": "20%",
	"skeleton01": "#f5f3f1",
	"disabled01": "#efedea",
	"supportBrand02": "#ffead4",
	"skeleton02": "#efedea",
	"contentPositive": "#017a39",
	"borderSubtle": "#f5f3f1"
};
export default ___CSS_LOADER_EXPORT___;
